import { render } from "./SmallRangeIndicator.vue?vue&type=template&id=980e1376&scoped=true&lang=html"
import script from "./SmallRangeIndicator.vue?vue&type=script&lang=js"
export * from "./SmallRangeIndicator.vue?vue&type=script&lang=js"

import "./SmallRangeIndicator.vue?vue&type=style&index=0&id=980e1376&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-980e1376"]])

export default __exports__